import { MetaReducer } from '@ngrx/store';

import { sessionStorageMetaReducer } from './session.storage.meta-reducer';

export const metaReducers: MetaReducer[] = [sessionStorageMetaReducer];

export * from './session.storage.meta-reducer';
